import type { FaireProductEntity } from "../../entity_types/product";

export const p_66phyx6bjx: FaireProductEntity = {
  token: "p_66phyx6bjx",
  type: "product",
  name: "EXTRA MILE - Earth-Tone Chunky Sneakers w/ Contrast Lacing",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/2a24b62bcb34f85ed9dbbbeceb2adbd0fac31b689fdcf556533bf6eedc413a01.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/483a899f1de11b00642d3a0e5def82b90c696f546a5acb1449300b5457912f59.jpeg",
    "https://cdn.faire.com/fastly/0ecb030ed63f1e9ef94023198a1a0bee35434818d03a669336acf6429e707752.jpeg",
    "https://cdn.faire.com/fastly/fd8ad5771a9f7480767381000ae3d5e18478274661f8947ddf54dd1320d6929d.jpeg",
    "https://cdn.faire.com/fastly/f0f0a48e9a0701684889f7a543587fa8152a03a13501b251dc13d9e90e5122b3.jpeg",
    "https://cdn.faire.com/fastly/8c02e1c650b4ecc4ffa3ad08aa56a494d81d83c302541bd4d1ec9dd7f1650fc7.jpeg",
    "https://cdn.faire.com/fastly/35786516fc5c0909aea9f32107cfd57dcd423114be9dcc2196afcdd2f6e4b400.jpeg",
    "https://cdn.faire.com/fastly/4b88c5a21d1116ce68fda157f0e6c33c6896d9b4a5193af5ec6570b526059a27.jpeg",
    "https://cdn.faire.com/fastly/323314026ac06d9cb4d61a1acba4750449561c0435047a33d5b5cc0706ab7f7e.jpeg",
    "https://cdn.faire.com/fastly/0bcc2cee4fd07b587661de36cd1ef9c87d003194c876ffb93a54860c88b49ca7.jpeg",
    "https://cdn.faire.com/fastly/b1f2bf97c1b87c83f2046314c09b431af9e0ec038ae2daf90f43e3201c163205.jpeg",
    "https://cdn.faire.com/fastly/999d8a26c4d16fb315ee4e7e6a67423e00bf42945e2dfe87936c8b07133bcbde.jpeg",
    "https://cdn.faire.com/fastly/1dc6693754375dcb9248bd7827cdbaff38bb73e064ca24a754cbbdfcbefb02bd.jpeg",
    "https://cdn.faire.com/fastly/0b90b2e50c29f7893f0ce20b54c2b1c284777296873fc8eecfcb4c6a949d60f4.jpeg",
    "https://cdn.faire.com/fastly/41795d7fc2b9e80ed9eee780d2a6cb7f2335c38952b6b5d39a33ebebeac03b36.jpeg",
  ],
  priceDollars: 16,
  description:
    "Crafted with a rugged yet refined design, the Extra Mile sneaker features a sturdy sole perfect for those who go the distance in fashion and life. The soft earthy upper, accented with vibrant contrast laces, adds a touch of nature's palette, making these sneakers ideal for both urban escapades and nature-inspired outings. The design is both functional and fashionable, ensuring you're ready for any terrain while keeping your style on point. Make Extra Mile your companion on your next adventure, where every step is a statement of your bold, adventurous spirit.\n\n• Low Top Sneakers\n• Contrast Lacing\n• Rubber Sole\n• Colors: Sand, White, Chestnut",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:13.892Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
